module.exports = __webpack_public_path__ + "img/admin-survey.0bc0a2a0.png";